import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/styles';
import {
    Button,
    IconButton,
    TextField,
    Grid,
    Box,
    Divider,
    Tooltip
} from '@material-ui/core';
import { Add, Delete } from '@material-ui/icons';
import { ListTags } from "components";

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1)
    },
    deleteContainer: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    deleteButton: {
        color: theme.palette.error.main
    },
    scoreContainer: {
        width: '50%'
    },
    selectContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        minWidth: '14rem',
        margin: theme.spacing(1)
    },
    ruleDivider: {
        marginTop: '10px',
        marginBottom: '10px'
    },
    questionError: {
        color: theme.palette.error.main,
        fontSize: '11px',
        marginLeft: '14px',
        marginRight: '14px',
        fontWeight: '400 !important',
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        letterSpacing: "0.33px",
    }
}));

const ScoreBuilder = props => {
    const { survey } = props;
    const { 
        thisSurvey,
        isTemplateReadOnly,
        handleChange,
        shouldShowError,
        getErrorMessage,
        onBlur,
        onFocus
    } = survey;
    const classes = useStyles();
    let [promoterScore, setPromoterScore] = useState(thisSurvey.postProcessing?.promoterScores || []);
    
    useEffect(() => {
        if (thisSurvey.postProcessing?.promoterScores) {
            let updatedQuestions = thisSurvey.questions?.filter(question => question.type === 'rating').map(question => question.title || question.name) || [];
            let updatedPromoterScores = thisSurvey.postProcessing.promoterScores;
            updatedPromoterScores = updatedPromoterScores.map(score => {
              return {
                ...score,
                questions: score.questions?.filter(question => updatedQuestions.includes(question))
              };
            });
            setPromoterScore(updatedPromoterScores);
        }
    }, [thisSurvey.questions]);

    useEffect(() => {
        handleChange({
            target: {
                name: 'postProcessing',
                value: {
                    ...thisSurvey.postProcessing,
                    promoterScores: promoterScore
                }
            }
        })
    }, [promoterScore]);

    const modifyQuestions = (questions, index) => {
        setPromoterScore(promoterScore.map((score, i) => {
            if (i === index) {
                return {
                    ...score,
                    questions
                };
            }
            return score;
        }));
    };
    
    const modifyScoreName = (scoreName, index) => {
        setPromoterScore(promoterScore.map((score, i) => {
            if (i === index) {
                return {
                    ...score,
                    scoreName
                };
            }
            return score;
        }));
    };
    
    const addPromoterScore = () => {
        setPromoterScore([
            ...promoterScore,
            {
                scoreName: '',
                questions: []
            }
        ]);
    };
    
    const deletePromoterScore = (index) => {
        setPromoterScore(promoterScore.filter((score, i) => i !== index));
    };

    return (
        <div>
            {!isTemplateReadOnly() && (
                thisSurvey.questions?.filter(question => question.type === 'rating').length > 0 ? (
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        startIcon={<Add />}
                        onClick={() => addPromoterScore()}
                    >
                        Add Promoter Score
                    </Button>
                ) : (
                    <Tooltip title="No rating type questions available for this survey">
                        <span>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                startIcon={<Add />}
                                disabled
                            >
                                Add Promoter Score
                            </Button>
                        </span>
                    </Tooltip>
                ))
            }
            {promoterScore.map((score, index) => (
                <Box key={index}>
                    <Divider className={classes.ruleDivider} />
                    <div className={classes.selectContainer}>
                        <div className={classes.scoreContainer}>
                            <Grid>
                                <TextField
                                    label="Score Name"
                                    fullWidth
                                    margin="dense"
                                    name="scoreName"
                                    variant="outlined"
                                    required
                                    onFocus={onFocus}
                                    onBlur={onBlur}
                                    value={score.scoreName}
                                    disabled={isTemplateReadOnly()}
                                    onChange={(e) => {modifyScoreName(e.target.value, index)}}
                                    error={shouldShowError(
                                        `postProcessing.promoterScores.${index}.scoreName`
                                    )}
                                    helperText={getErrorMessage(
                                        `postProcessing.promoterScores.${index}.scoreName`
                                    )}
                                />
                            </Grid>
                            <Grid>
                                <ListTags
                                    label={`Questions *`}
                                    userTags={false}
                                    tags={score.questions || []}
                                    isTemplateReadOnly={isTemplateReadOnly()}
                                    modifyTags={(updatedTags) => modifyQuestions(updatedTags, index)}
                                    allTags={thisSurvey.questions?.filter(question => question.type === 'rating').map(question => question.title || question.name)}
                                />
                                {(score.questions.length === 0 && score.scoreName) && (
                                    <div className={classes.questionError}>{`"Questions" is not allowed to be empty`}</div>
                                )}
                            </Grid>
                        </div>
                        <div className={classes.deleteContainer}>
                            <Grid>
                                {!isTemplateReadOnly() && (
                                    <IconButton
                                        className={classes.deleteButton}
                                        onClick={() => deletePromoterScore(index)}
                                    >
                                        <Delete />
                                    </IconButton>
                                )}
                            </Grid>
                        </div>
                    </div>
                </Box>
            ))}
        </div>
    );
};

export default ScoreBuilder;